<template>
  <div>
    <v-app id="dashboard-view">
      <Toolbar />
      <Drawer />
      <div
        class="floatting-how-to"
        v-if="showSlidePanelVideo()"
        @click="slidePanel()"
      >
        <div>H</div>
        <div>O</div>
        <div>W</div>
        <br />
        <div>T</div>
        <div>O</div>
      </div>
      <VideoSlidePanel
        v-if="user && user.videos && user.videos.length"
        class="floatting-panel-video"
        :drawer="drawer"
        :close="closeDrawer"
      />
      <div style="height:100%" v-if="!checkCustomInstitute()">
        <v-container fill-height class="dashboard-main-view header-fix-cp3">
          <div class="breadcrumbs-div">
            <!-- <v-breadcrumbs :items="items" large></v-breadcrumbs> -->
            <!-- <v-breadcrumbs large></v-breadcrumbs> -->

            <v-breadcrumbs :items="items">
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item :to="item.to" :disabled="item.disabled" @click="clickBreadcrumb(item)"  :class="item.class" >
                  <span class="light-text" v-if="item.isFirst">{{
                    item.text
                  }}</span>
                  <span v-else>{{ item.text }}</span>
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
          </div>
          <router-view></router-view>
        </v-container>
      </div>
      <div class="dashboard-myt" v-else>
        <router-view></router-view>
      </div>
      <AlertBox
        :width="modalwidth"
        :onClose="onClose"
        :component="cComponent"
        :status="status"
        :data="alertBoxData"
        :persistent="persistent"
      />
    </v-app>
  </div>
</template>

<script>
import MYTDashboard from "./pages/mytuser/MYTDashboard.vue";
import Toolbar from "@/components/core/Toolbar.vue";
import Drawer from "@/components/core/Drawer.vue";
import VideoSlidePanel from "@/components/core/VideoSlidePanel.vue";
import { mapMutations, mapState, mapActions } from "vuex";
import createActivityDetector from "activity-detector";
import { detect } from "detect-browser";
import menuList from "../utils/menu";
import constants from "@/utils/constants.js";
let sendRelicInterval;

export default {
  name: "DashboardView",
  components: {
    Toolbar,
    Drawer,
    VideoSlidePanel,
    MYTDashboard
  },
  data() {
    return {
      items: [],
      activityDetector: null,
      totalTime: 0,
      interval: null,
      modalwidth: null,
      cComponent: "",
      alertBoxData: {},
      persistent: false,
      status: false,
      browserInfo: null,
      modules: [],
      drawer: false,
      routesToVisible: [],
      // menus: [],
      onPopUpFeedBackModal: false
    };
  },
  methods: {
    ...mapActions({
      updateUserActivity: "userStore/updateUserActivity",
      me: "userStore/me",
      getInstituteDetails: "userStore/getInstituteDetails",
      getListOfPendingTests: "userStore/getListOfPendingTests",
      getUserFeedbackQuestion: "utilStore/getUserFeedbackQuestion",
      logData: "testStore/logData",
    }),
    ...mapMutations("app", ["addBreadCrumbChilde", "onMenuSelected"]),
    checkBrowserSupport() {
      if (!this.browserInfo || !this.browserInfo.name) return false;
      let browserName = this.browserInfo.name;
      let nAgent = navigator.userAgent.toLowerCase();
      let isSupported = true;
      this.UNSUPPROTED_BROWSERS.forEach((browser) => {
        if (nAgent.includes(browser)) {
          isSupported = false;
        }
      });

      if (
        isSupported &&
        (browserName == "firefox" ||
          browserName == "chrome" ||
          browserName == "safari" ||
          browserName == "crios" ||
          browserName == "fxios" ||
          browserName == "ios")
      ) {
        return true;
      }
      return false;
    },

    getBreadCrumb() {
      if (!this.selectedMenu.hideFromBreadCrumb) {
        this.items = [
          {
            text: this.selectedMenu.label,
            disabled: false,
            to: { name: this.selectedMenu.toRoute },
            isFirst: true
          }
        ];
      }
      /*if (this.selectedMenu.id === "CO-TEST" &&this.user.role_id !== this.roleIds.TR) {
                this.UpdateTestMenuList();
            }*/
      if (this.selectedSubMenu && !this.selectedSubMenu.hideFromBreadCrumb) {
        if (this.selectedSubMenu.text) {
          this.items.push({
            text: this.selectedSubMenu.text,
            disabled: false,
            to: { name: this.selectedSubMenu.toRoute }
          });
        }
      }
      if (this.breadCrumbChilde && this.breadCrumbChilde.length) {
        this.items = this.items.concat(this.breadCrumbChilde);
      }
      if (
        this.items &&
        this.items.length == 1 &&
        this.selectedMenu &&
        this.selectedMenu.label === "Home"
      ) {
        this.items = [];
      }
    },
    getPendingTests() {
      // //this.$root.showLoader = true;
      if (this.pendingTestList == null) {
        this.getListOfPendingTests({})
          .then((resp) => {
            if (resp && resp.list) {
              this.redirectToPendingTest();
            }
          })
          .catch((err) => {
            // //this.$root.showLoader = false;
            let errObj= ''
            if (e && e.data && e.data.errors ) {
                errObj=e.data.errors
            }else if (e && e.data) {
                errObj=e.data                        
            }else{
                errObj  = e
            }
            let error_log= new Error(`
            **PENDING **LIVE ST::${this.user.id+""},
            api:'pending',
            error:${JSON.stringify(errObj)},
            networkStatus: ${navigator.onLine},
            user_id: ${this.user.id}`)
            localStorage.setItem('error_live_test',error_log)
            this.sendLogData(errObj,'pending','live-test-api')
          });
      } else {
        this.redirectToPendingTest();
      }
    },
    redirectToPendingTest() {
      if (this.pendingTestList.length > 0) {
        let currentTestId = this.pendingTestList[0].test_id;
        let currentInstituteId = this.pendingTestList[0].test_institute_id;
        let testScheduleId = this.pendingTestList[0].test_schedule_id;
        if (currentTestId && currentInstituteId && testScheduleId) {
          this.$router.push({
            name: "test",
            params: {
              test_id: currentTestId,
              test_institute_id: currentInstituteId,
              test_schedule_id: testScheduleId,
              student_id:this.user.id
            }
          });
        }
      } else {
        this.checkIfMobileVerified();
      }
    },
    checkIfMobileVerified() {
      //this.$root.showLoader = false;
      let showVerifyTelegramBox = sessionStorage.getItem(
        "showVerifyTelegramBox"
      );
      showVerifyTelegramBox = showVerifyTelegramBox
        ? JSON.parse(showVerifyTelegramBox)
        : "";
      if (showVerifyTelegramBox) {
        sessionStorage.setItem("showVerifyTelegramBox", false);
        this.alertBoxData = {};
        this.modalwidth = "600px";
        this.status = true;
        this.cComponent = "components/common/VerifyMobile";
        this.$forceUpdate();
      } else {
        this.checkFeedbackModalData();
      }
    },
    checkFeedbackModal(data) {
      //this.$root.showLoader = false;
      let onPopUpFeedBackModal = sessionStorage.getItem("onPopUpFeedBackModal");
      onPopUpFeedBackModal = JSON.parse(onPopUpFeedBackModal);
      if (this.user && onPopUpFeedBackModal && onPopUpFeedBackModal != null) {
        this.alertBoxData = data;
        this.modalwidth = "767px";
        this.status = true;
        this.alertBoxData.persistent = true;
        this.cComponent = "components/common/FeedBackModal";
        this.$forceUpdate();
      }
    },
    onClose(data) {
      this.status = data.status;
      if (data && data.isCloseAutoSubmit) {
        sessionStorage.removeItem('limitCrossed')
      }
      if (data && data.checkIfMobileVerified && !this.onPopUpFeedBackModal) {
        this.checkFeedbackModalData();
        this.onPopUpFeedBackModal = true;
      }else if ( data&& (data.checkIfMobileVerified || data.showAutoSubmitPopup )&&sessionStorage.getItem('limitCrossed')){
        this.showTestAutoSubmitPopup()
      }
    },
    UpdateTestMenuList() {
      this.modules = JSON.parse(localStorage.getItem("modules"));
      let is_selected_submenu = false;
      for (let i = 0; i < this.modules.length; i++) {
        if (
          (this.selectedSubMenu.id === this.modules[i].module_id ||
            this.selectedSubMenu.id === this.modules[i].parent_module_id) &&
          this.modules[i].is_selected === 1
        ) {
          this.onMenuSelected({
            main: this.selectedMenu,
            sub: this.selectedSubMenu
          });
          is_selected_submenu = true;
        }
      }
      if (this.selectedSubMenu && this.selectedSubMenu.id == 13) {
        this.onMenuSelected({
          main: this.selectedMenu,
          sub: this.selectedSubMenu
        });
        is_selected_submenu = true;
      }
      if (!is_selected_submenu) {
        let route = JSON.parse(localStorage.getItem("module-route"));
        this.onMenuSelected({ main: this.selectedMenu, sub: route });
      }
    },
    slidePanel() {
      this.drawer = true;
    },
    closeDrawer(val, videoId) {
      if (videoId) {
        this.cComponent = "components/common/VideoPlayer";
        this.status = true;
        this.modalwidth = "500px";
        this.alertBoxData = {
          id: videoId
        };
      }
      this.drawer = false;
    },
    getMenus() {
      // if (this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id)) {
      //        this.menus = menuList.MENU.CUSTOMMENU;
      // }else if (
      //   this.user &&
      //   (this.roleIds.CO === this.user.role_id ||
      //     this.roleIds.ID === this.user.role_id)
      // ) {
      //   this.menus = menuList.MENU.COORDINATOR;
      // } else if (this.user && this.roleIds.ST === this.user.role_id) {
      //   this.menus = menuList.MENU.STUDENT;
      // } else if (this.user && this.roleIds.PA === this.user.role_id) {
      //   this.menus = menuList.MENU.PARENT;
      // } else if (this.user && this.roleIds.ED === this.user.role_id) {
      //   this.menus = menuList.MENU.DEO;
      // } else if (this.user && this.roleIds.TR === this.user.role_id) {
      //   this.menus = menuList.MENU.TEACHER;
      // }
      this.menus.map((m) => {
        if (!this.routesToVisible.includes(m.toRoute)) {
          this.routesToVisible.push(m.toRoute);
        }
        m.sub_menus.map((sm) => {
          if (!this.routesToVisible.includes(sm.toRoute)) {
            this.routesToVisible.push(sm.toRoute);
          }
        });
      });
    },
    showSlidePanelVideo() {
      if (
        this.routesToVisible &&
        this.routesToVisible.length &&
        this.routesToVisible.includes(this.$route.name) &&
        this.user &&
        this.user.videos &&
        this.user.videos.length
      ) {
        return true;
      }
      return false;
    },
    checkFeedbackModalData() {
      if (
        this.user &&
        this.roleIds.ST === this.user.role_id &&
        this.user.institute
      ) {
        this.getUserFeedbackQuestion().then((response) => {
          let question = {};
          if (
            response &&
            response.feedbackQuestions &&
            response.feedbackQuestions.length !== 0
          ) {
            question.qData = response.feedbackQuestions;
            question.target_year = response.target_year;
            this.checkFeedbackModal(question);
          }else if(sessionStorage.getItem('limitCrossed')){
            this.showTestAutoSubmitPopup()
          }
        });
      }
    },
    save(page) {
      let ttime = JSON.parse(localStorage.getItem("active_total_time"));
      let pageName = this.$route.name;
      let reqData = {
        total_time: ttime ? ttime : 0,
        page_name: page ? page : pageName
      };
      let userToken = JSON.parse(
        JSON.stringify(sessionStorage.getItem("auth_token"))
      );
      if (userToken && userToken.length &&!this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id)) {
        this.updateUserActivity(reqData)
          .then((response) => {
            // Success
            localStorage.setItem("active_total_time", JSON.stringify(0));
            this.totalTime = 0;
          })
          .catch((err) => {});
      }
    },

    checkCustomInstitute() {
      return this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id);
    },
    sendLogData(error, apiname,type){
        let logData = {
          api: apiname,
          response:error,
          network_status: navigator.onLine,
          user_id:this.user.id,
          type
        }
        this.logData(logData).catch(err=>{
          let logdata = localStorage.getItem('logdata')
          if(logdata){
            logdata = JSON.parse(logdata)
          }else{
            logdata = [];
          }
          logdata.push(logData)
          localStorage.setItem('logdata',JSON.stringify(logdata))
        })
    },
    sendStoredLogData(){
      let logdata = JSON.parse(localStorage.getItem('logdata'))
      if(logdata && logdata.length){

      logdata.map(l=>this.logData(l))
      localStorage.removeItem('logdata')
      }
    },
    showTestAutoSubmitPopup(){
      this.alertBoxData = {noOfTimesTabChanged:3,persistent:true};
      this.modalwidth = "400px";
      this.status = true;
      this.cComponent = "components/student/Tests/PastTests/TabSwitchPopup";
      // this.$forceUpdate();
    },
    clickBreadcrumb(item){
      item && item.click && item.click()
    }
  },
  computed: {
    ...mapState("app", ["selectedMenu", "selectedSubMenu", "breadCrumbChilde",'menus']),
    ...mapState("userStore", ["user", "pendingTestList", "myInstitute"])
  },
  destroyed() {
    if (this.interval) clearInterval(this.interval);
    clearInterval(sendRelicInterval)

  },
  async mounted() {
    this.browserInfo = detect();
    let userToken = JSON.parse(this.$cookies.get('userToken'));
    let auth_token = sessionStorage.getItem("auth_token");
    if ((this.myInstitute.id === constants.ONLINE_INSTITUTE_ID) && userToken && (auth_token != userToken)){
      await this.delayTime(1000);
    }
    // this.getInstituteDetails();
    if (!this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id)) {
      
      if (
        this.user &&
        this.roleIds.ST === this.user.role_id &&
        this.checkBrowserSupport() 
      ) {
        this.getPendingTests();
      } else {
        this.checkIfMobileVerified();
      }
    }

    let start, end;
    this.activityDetector = createActivityDetector({
      timeToIdle: 1000, // wait 5s of inactivity to consider the user is idle
      autoInit: false, // I don't want to start the activity detector yet.
      ignoredEventsWhenIdle: []
    });
    this.activityDetector.init();

    this.activityDetector.on("idle", () => {
      end = new Date();
      this.totalTime = JSON.parse(localStorage.getItem("active_total_time"));
      if (end && start) {
        let betTime = this.totalTime + (end.getTime() - start.getTime());
        localStorage.setItem("active_total_time", JSON.stringify(betTime));
      }
    });
    this.activityDetector.on("active", () => {
      start = new Date();
    });

    this.interval = window.setInterval(() => {
      this.save();
    }, 60000);
    if (!this.selectedMenu.hideFromBreadCrumb) {
      this.items = [
        {
          text: this.selectedMenu.label,
          disabled: false,
          to: this.selectedMenu.toRoute
        }
      ];
    }
    /*if(this.user.role_id !== this.roleIds.TR && this.selectedMenu.id === 'CO-TEST' ) {
			this.UpdateTestMenuList();
			this.items.push({
                text: this.selectedSubMenu.text,
                disabled: false,
                to: this.selectedSubMenu.toRoute,
            });
		}*/
    if (this.selectedSubMenu && !this.selectedSubMenu.hideFromBreadCrumb) {
      this.items.push({
        text: this.selectedSubMenu.text,
        disabled: false,
        to: this.selectedSubMenu.toRoute
      });
    }
    if (
      this.items &&
      this.items.length == 1 &&
      this.selectedMenu &&
      this.selectedMenu.label === "Home"
    ) {
      this.items = [];
    }
    sendRelicInterval=setInterval(()=>{
      if(navigator.onLine){
        this.sendStoredLogData()
      }
    },1000)
  },

  watch: {
    selectedMenu(val) {
      this.addBreadCrumbChilde([]);
      this.getBreadCrumb();
    },
    selectedSubMenu(val) {
      this.addBreadCrumbChilde([]);
      this.getBreadCrumb();
    },
    breadCrumbChilde(val) {
      this.getBreadCrumb();
    },
    "$route.name"(newval, oldval) {
      this.save(oldval);
    },
    menus(val){
      if (val && val.length) {
        this.getMenus();
      }
    }
  }
};
</script>
